import { FC } from "react";
import billingsTaxiUnbilledOrderListingFiltersBadgeListHelper from "./billings-taxi-unbilled-order-listing-filters-badge-list.helper";
import BillingsTaxiUnbilledOrderListingFilter from "../../types/billings-taxi-unbilled-order-listing-filter";
import ListingFilterBadgeListComponent from "../../../../../../../common/components/listing/filter/badge-list/listing-filter-badge-list.component";

type BillingsTaxiUnbilledOrderListingFiltersListProps = {
  filters: BillingsTaxiUnbilledOrderListingFilter[];
  onDeleteFilterClick: (filterIndex: number) => void;
  onDeleteAllFiltersButtonClick: () => void;
};

const BillingsTaxiUnbilledOrderListingFiltersBadgeListComponent: FC<
  BillingsTaxiUnbilledOrderListingFiltersListProps
> = (props) => {
  const badges =
    billingsTaxiUnbilledOrderListingFiltersBadgeListHelper.getBadges(
      props.filters
    );

  return (
    <ListingFilterBadgeListComponent
      badges={badges}
      onDeleteAll={props.onDeleteAllFiltersButtonClick}
      onDelete={props.onDeleteFilterClick}
    />
  );
};

export default BillingsTaxiUnbilledOrderListingFiltersBadgeListComponent;
